module.exports = __webpack_public_path__ + "static/media/error.8cb5b084.svg";